<template>
  <v-dialog :value="value" max-width="720" scrollable @input="$emit('input', $event)">
    <v-card v-if="item" class="rounded-lg analysis-dialog">
      <div class="analysis-dialog__header">
        <div class="analysis-dialog__heading">
          <div class="text-overline grey--text text--darken-1 analysis-dialog__overline">{{ label }}</div>
          <div class="text-h6 font-weight-bold">Análise da Administração Judicial</div>
          <div class="d-flex align-center flex-wrap mt-1">
            <v-chip small label :color="status.color" text-color="white" class="mr-3">{{ status.label }}</v-chip>
            <span class="text-caption grey--text text--darken-1">
              Solicitada em {{ $moment(item.created_at).utc().format('DD/MM/YYYY') }}
              <template v-if="item.analyzed_at"> · Analisada em {{ $moment(item.analyzed_at).utc().format('DD/MM/YYYY') }}</template>
            </span>
          </div>
        </div>
        <v-btn icon aria-label="Fechar a análise" @click="$emit('input', false)"><v-icon>mdi-close</v-icon></v-btn>
      </div>
      <v-divider />

      <v-card-text class="analysis-dialog__body" tabindex="0">
        <div v-if="item.small_reason" class="analysis-dialog__summary">
          <div class="objection-field__label">Resumo</div>
          <div class="objection-field__text">{{ summary }}</div>
        </div>
        <div class="objection-field__label mt-4">Análise completa</div>
        <div class="analysis-dialog__content" v-html="item.reason"></div>
      </v-card-text>

      <v-divider />
      <v-card-actions class="px-4 py-3">
        <v-spacer />
        <v-btn color="primary" elevation="0" aria-label="Fechar a janela com a análise" @click="$emit('input', false)">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { reviewStatus, analysisSummary } from '@/common/util/objection-phase';

// Análise da Administração Judicial de um pedido de revisão (credor e procurador).
export default {
  name: 'ReviewAnalysisDialog',
  props: {
    value: { type: Boolean, default: false },
    item: { type: Object, default: null },
    label: { type: String, default: '' },
  },
  computed: {
    status() { return reviewStatus(this.item); },
    summary() { return analysisSummary(this.item); },
  },
};
</script>

<style>
.analysis-dialog__header { display: flex; align-items: flex-start; gap: 12px; padding: 16px 16px 14px 20px; background: #f5f5f5; }
.analysis-dialog__heading { flex: 1; min-width: 0; }
.analysis-dialog__overline { line-height: 1.4 !important; }
.analysis-dialog__body { padding: 20px !important; max-height: 60vh; }
.analysis-dialog__summary { background: #f7f9fc; border: 1px solid #e3e8f0; border-radius: 8px; padding: 12px 14px; }
.analysis-dialog__content { font-size: 14px; line-height: 1.6; color: #424242; }
.analysis-dialog__content,
.analysis-dialog__content p,
.analysis-dialog__summary .objection-field__text { text-align: left !important; }
.analysis-dialog__content p { margin-bottom: 10px; }
.objection-analysis { background: #fafafa; border-radius: 6px; padding: 10px 12px; }
.objection-analysis--pending { background: #f5f7fa; }
.objection-analysis__summary { display: -webkit-box; -webkit-line-clamp: 3; -webkit-box-orient: vertical; overflow: hidden; text-align: left; }
.objection-section-title { margin: 8px 0 12px; }
</style>
